import * as React from "react";
import { Annotation } from "../../api";

interface AnnotationTrackScrubberProps {
  genomeLength: number;
  windowBeginsPercentage: number;
  contigPositions: number[];
  jumpToPosition: (offsetX: number, genomeLength: number) => void;
  jumpToAnnotation: (annotation: Annotation) => void;
  searchResults: Annotation[];
}

// Like in audio tracks where you can click on part of the audio wavelength
// to quickly move to that bit
class AnnotationTrackScrubber extends React.PureComponent<AnnotationTrackScrubberProps> {
  renderContigDividers() {
    const dividers = [];
    let runningSum = 0;
    for (let i = 0; i < this.props.contigPositions.length; i++) {
      runningSum += this.props.contigPositions[i];
      dividers.push(
        <div
          key={"divider-" + i}
          className="annotation-track-scrubber__contig-divider"
          style={{
            left: (runningSum / this.props.genomeLength) * 100 + "%",
          }}
        />
      );
    }
    return dividers;
  }

  jumpTrackToCursor = (e: React.MouseEvent) => {
    this.props.jumpToPosition(e.nativeEvent.offsetX, this.props.genomeLength);
  };

  jumpToBookmark = (event: React.MouseEvent, annotation: Annotation) => {
    event.stopPropagation();
    this.props.jumpToAnnotation(annotation);
  };

  renderSearchBookmarks = () => {
    if (!this.props.searchResults) {
      return null;
    }

    return this.props.searchResults.map((annotation) => (
      <div
        key={"search-bookmark-" + annotation.uuid}
        onClick={(e) => this.jumpToBookmark(e, annotation)}
        className="annotation-track-scrubber__search-bookmark"
        style={{
          left: (annotation.absolute_start_loc / this.props.genomeLength) * 100 + "%",
        }}
      />
    ));
  };

  render() {
    return (
      <>
        <div className="annotation-track-scrubber" onClick={(e) => this.jumpTrackToCursor(e)} />

        <div
          className="annotation-track-scrubber__window"
          style={{
            left: this.props.windowBeginsPercentage + "%",
          }}
        />
        {this.renderContigDividers()}
        {this.renderSearchBookmarks()}
      </>
    );
  }
}

export default AnnotationTrackScrubber;
